import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import { ApiReturn } from '@/modules/api.service';
import { DataEHoraAmigavel } from '@/shared/utils/datas';
import { DeleteNotificaco, DeleteTodasNotificacoes, GetNotificacoes, } from '@/modules/system/notificacoes/notificacoes.service';
import { Fragment, useMemo, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { NotificacaoDto } from '@/api.types';
import { toast } from 'react-toastify';

const OPCOES_TIPO = [
  { value: '', label: 'Todos os tipos' },
  { value: 'ACAO', label: 'Ação' },
  { value: 'LOTACAO', label: 'Lotação' },
  { value: 'PESSOA', label: 'Pessoa' },
] as const;

export default function NotificacoesIndexPage() {
  const [loading, setLoading] = useState<boolean>(true);
  const [reload, setReload] = useState<boolean>(false);
  const [modalExcluirTodas, setModalExcluirTodas] = useState(false);
  const [filtroTipo, setFiltroTipo] = useState<string>('');
  const [registros, setRegistros] = useState<ApiReturn<NotificacaoDto>>({
    objects: [],
    count: 0,
  });

  const registrosFiltrados = useMemo(() => {
    if (!filtroTipo) return registros.objects;
    return registros.objects.filter((item) => item.tipo === filtroTipo);
  }, [registros.objects, filtroTipo]);

  useEffect(() => {
    GetNotificacoes(false)
      .then((result) => {
        setRegistros(result);
        setLoading(false);
        setReload(false);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, [reload]);

  function handleClick(id: string) {
    setReload(true);
    DeleteNotificaco(id)
      .then((res) => {
        toast.success(res + '');
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }

  function handleExcluirTodas(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    setModalExcluirTodas(false);
    DeleteTodasNotificacoes()
      .then((res) => {
        toast.success(res + '');
        setReload(true);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }

  const getLinkParaNotificacao = (notificacao: NotificacaoDto): string | null => {
    if (!notificacao.idregistro) {
      return null;
    }

    switch (notificacao.tipo) {
      case 'ACAO':
        return Links.Acoes_Editar + '/' + notificacao.idregistro;
      case 'LOTACAO':
        return Links.Vinculos_Editar + '/' + notificacao.idregistro;
      case 'PESSOA':
        return Links.Pessoa_Editar + '/' + notificacao.idregistro;
      default:
        // Fallback para compatibilidade com notificações antigas sem tipo
        return Links.Acoes_Editar + '/' + notificacao.idregistro;
    }
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-md-8">
          <h3 className="pt-4">Notificações</h3>
          <span className="blockquote-footer pb-4 text-end">
            Suas notificações ({filtroTipo ? registrosFiltrados.length : registros.count}).
          </span>
        </div>
        <div className="col-md-4 text-end pt-4">
          {!loading && registros.count > 0 && (
            <button
              type="button"
              className="btn btn-outline-danger btn-sm"
              onClick={() => setModalExcluirTodas(true)}
            >
              Excluir todas
            </button>
          )}
        </div>
        <div className="col-12 mb-3">
          <label htmlFor="filtro-tipo" className="form-label me-2">Filtrar por tipo:</label>
          <select
            id="filtro-tipo"
            className="form-select form-select-sm w-auto d-inline-block"
            value={filtroTipo}
            onChange={(e) => setFiltroTipo(e.target.value)}
          >
            {OPCOES_TIPO.map((op) => (
              <option key={op.value || 'todos'} value={op.value}>
                {op.label}
              </option>
            ))}
          </select>
        </div>
        <hr className="pb-4" />

        {/* Tabela */}
        {!loading && (
          <div className="tabela">
            <table className="table table-sm table-striped table-hover">
              <thead>
                <tr className="justify-content-center">
                  <th scope="col">Data</th>
                  <th scope="col">Título</th>
                  <th scope="col">Detalhes</th>
                  <th scope="col">Ações</th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {registros &&
                  typeof registros !== 'undefined' &&
                  registros !== null &&
                  registrosFiltrados.map((item, index) => (
                    <tr key={index} title={`${item.idregistro}`}>
                      <td>{DataEHoraAmigavel(item.criadoEm)}</td>
                      <td>
                        {(() => {
                          const link = getLinkParaNotificacao(item);
                          return link ? (
                            <Link
                              to={link}
                              target="_blank"
                            >
                              {item.titulo}
                            </Link>
                          ) : (
                            <span>{item.titulo}</span>
                          );
                        })()}
                      </td>
                      <td>{item.detalhes}</td>
                      <td className="justify-content-center">
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          title="Excluir Notificação"
                          onClick={() => handleClick(item.id)}
                        >
                          Excluir
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
        {loading && <Loading />}
      </div>

      <ModalExcluir
        show={modalExcluirTodas}
        handleExcluir={handleExcluirTodas}
        handleHide={() => setModalExcluirTodas(false)}
        mensagemPersonalizada="Tem certeza que deseja excluir todas as notificações? Esta ação não pode ser desfeita."
      />
    </Fragment>
  );
}
